
//Definición de defaults

export const defaultZona: ZonaProps = {
    idZona:         0,
    descripcion:    '',  
    activo:         false,
}

// Creación de interfaces

export interface ZonaProps{
    idZona:         number;
    descripcion:    string;
    activo:         boolean;
}